import React, { useEffect, useState, useContext } from "react";
import { Redirect } from "react-router-dom";
import qs from "qs";
import Products from "components/Products";
import { StoreContext } from "components/StoreContext";
import NoResults from "containers/Error/components/noResults";
import HeadTags from "components/HeadTags";

const Search = () => {
  const params = qs.parse(window.location.search.substr(1));
  const { store } = useContext(StoreContext);
  const keyword = params.keyword || "";
  const [showSearchResults, setShowSearchResults] = useState(true);
  const [searchResultsCount, setSearchResultsCount] = useState(null);

  const handleCallback = data => {
    if (data > 0) {
      setSearchResultsCount(data);
    } else {
      setSearchResultsCount(null);
      setShowSearchResults(false);
    }
  };

  useEffect(() => {
    if (store.loaded) {
      setSearchResultsCount(null);
      setShowSearchResults(true);
    }
  }, [store.loaded, keyword]);

  if (!keyword && !params.access_token) {
    return <Redirect to="/catalog" />;
  }

  if (!showSearchResults) {
    return <NoResults keyword={keyword} />;
  }

  return (
    <>
      <HeadTags title="Search" />
      <div className="page">
        <div className="page__body">
          <div className="page__container">
            {searchResultsCount ? (
              <div className="text-center my-4">
                <h2>
                  {`${searchResultsCount} result${
                    searchResultsCount === 1 ? "" : "s"
                  } for "${keyword}"`}
                </h2>
              </div>
            ) : (
              <div className="text-center my-4">
                <h2>{`Searching for "${keyword}"`}</h2>
              </div>
            )}
            <Products
              title=""
              keyword={keyword}
              returnProductCount={handleCallback}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Search;
